var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabsV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_942_",
    d: "M23.46,0H2.54C0.38,0,0,0.38,0,2.52v5.03c0,1.02,0,1.58,0.42,2.03c0.45,0.48,1.08,0.48,2.02,0.48h0.26 c0,0,0,0.01,0,0.01v6.27c0,0.31,0.09,0.6,0.24,0.85C2.8,17.44,2.7,17.73,2.7,18.03v6.27C2.7,25.24,3.49,26,4.46,26h4.18v-0.01 c0.01,0,0.02,0,0.03,0h14.79c1.88,0,2.54-0.18,2.54-2.17V2.52C26,0.54,25.68,0,23.46,0z M6.9,16.34H4.46v-6.27h2.48v1.26L6.9,16.34 z M6.89,24.31H4.46v-6.27h2.43V24.31z M24.27,23.82c0,0.15,0,0.34-0.01,0.48c-0.2,0.01-0.51,0.01-0.8,0.01H8.67V10.06 c0-0.46-0.2-0.88-0.51-1.19c-0.31-0.31-0.74-0.5-1.21-0.5H4.46c-0.03,0-0.06,0.01-0.08,0.01H2.44c-0.25,0-0.51,0-0.69-0.01 c-0.01-0.2-0.01-0.52-0.01-0.83V2.52c0-0.31,0-0.63,0.02-0.83c0.19-0.01,0.5-0.01,0.79-0.01h20.92c0.19,0,0.57,0,0.79,0.02 c0.02,0.19,0.02,0.52,0.02,0.82V23.82z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabsV);
export default __webpack_public_path__ + "static/media/TabsV.4cedcda51f664f61d046e933099530ce.svg";
export { ForwardRef as ReactComponent };